import {useState} from 'react';
import {twMerge} from 'tailwind-merge';

import LazyLoadVideo from '@/components_legacy/LazyLoadVideo';
import {useScreenDetectorFallback} from '@/hooks_legacy/useScreenDetectorFallback';
import AppLogo from '@/shared/components/AppLogo';
import AppleStoreLinkIcon from '@/shared/components/AppleStoreLinkIcon';
import GooglePlayLinkIcon from '@/shared/components/GooglePlayLinkIcon';
import {getMediaUrl} from '@/shared/lib/getMediaUrl';
import {localize} from '@/shared/services/i18n';

import SocialProofLogo from './SocialProofBlock';

const AppsSection = () => {
  const {isMobile} = useScreenDetectorFallback();
  const [videoLoaded, setVideoLoaded] = useState(false);

  const videoSrc = isMobile
    ? getMediaUrl('landing/Bottom_mob.webm')
    : getMediaUrl('landing/Bottom_desk.webm');

  return (
    <div className="relative h-fit select-none">
      <picture className="absolute inset-0 z-0 h-full">
        <source
          media="(max-width: 640px)"
          srcSet={getMediaUrl('landing/bottom_mob.webp')}
        />
        <img
          src={getMediaUrl('landing/bottom_desk.webp')}
          alt="couples"
          loading="lazy"
          className={twMerge(
            'absolute top-0 left-0 h-full w-full object-cover transition-opacity',
            videoLoaded ? 'opacity-0' : 'opacity-100'
          )}
        />
      </picture>
      <div className="absolute inset-0 z-10 h-full">
        <LazyLoadVideo
          videoSrc={videoSrc}
          videoLoaded={videoLoaded}
          setVideoLoaded={setVideoLoaded}
        />
      </div>
      <div className="relative top-0 z-20 flex h-full min-h-svh w-full flex-col items-center justify-center gap-10 py-14 sm:gap-32 sm:py-20">
        <div className="flex h-full flex-col items-center justify-center gap-1 sm:gap-12">
          <AppLogo className="h-19 w-30 text-white drop-shadow-logo sm:h-31.5 sm:w-50" />
          <SocialProofLogo />
        </div>
        <div className="flex h-full flex-col items-center gap-8">
          <span className="font-semibold text-secondary text-xl shadow-xs sm:text-2xl">
            {localize('landing_apps_download_now')}
          </span>
          <div className="flex flex-col gap-6 sm:flex-row sm:gap-16">
            <GooglePlayLinkIcon
              iconProps={{
                className:
                  'sm:h-[80px] sm:w-[240px] cursor-pointer h-[66px] w-[200px]',
              }}
            />
            <AppleStoreLinkIcon
              iconProps={{
                className:
                  'sm:h-[80px] sm:w-[240px] cursor-pointer h-[66px] w-[200px]',
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppsSection;
